// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"E2-z","subtitle":"F2-z","wrapper":"G2-z","leftArrow":"H2-z","rightArrow":"I2-z"};